export default __webpack_public_path__ + "media/fad97138b2bc9e45a05b858ac118599ccce6c60c087d297d30e505f3b480f40b.svg";